import request from '@/utils/request'
//import getBrowserLang from '@/i18n/index'

// 获取企业列表
  

export function getDevices(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/list',
    method: 'post',
    data
  })
}

//得设备树
export function getDeviceTree(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/tree',
    method: 'post',
    data
  })
}

//得到实时数据列表
export function getRealtimeList(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/realtimelist',
    method: 'post',
    data
  })
}

export function deleteDevice(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/delete',
    method: 'post',
    data
  })
}



//新增
export function createDevice(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/add',
    method: 'post',
    data
  })
}
//更新
export function updateDevice(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/edit',
    method: 'post',
    data
  })
}
//点名
export function rollCall(data) {  
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/cmd',
    method: 'post',
    data
  })
}
//这个方法得分步加载
export function queryHistoryData(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  return request({
    url: '/api/device/historylist',
    method: 'post',
    data
  })
}
//这个是现在用着的
export function queryHistoryAllData(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  data.needTotalCount= false;
  return request({
    url: '/api/device/historylistall',
    method: 'post',
    data
  })
}

//增加异步处理
export function queryHistoryWhenAllData(data) {  
 //return queryHistoryAllData(data);
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  data.needTotalCount= false;
  return request({
    url: '/api/device/historylistwhenall',
    method: 'post',
    data
  })
}

//Y转X轴
export function queryHistoryWhenAllDataYToX(data) {  
 //return queryHistoryAllData(data);
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  data.needTotalCount= false;
  return request({
    url: '/api/device/historylistwhenallytox',
    method: 'post',
    data
  })
}



//查询设备时间
export function queryServiceTime(data) { 
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  
  return request({
    url: '/api/device/currentdevicetime',
    method: 'post',
    data
  })
}

//导出变量
export function exportHisVariablesByFile(data) {
  data.lang = localStorage.getItem('lang') !=null ? localStorage.getItem('lang') : 'zh-CN'  
  data.needTotalCount= false;

  return request({
    url: '/api/device/export',
    method: 'post',
    data:data,
    responseType: 'blob',
    headers: {
      'Content-Type': 'application/json' // 明确指定请求内容类型
    }
  })
}

//去重末尾的0
export function  formatValueRemove0 (value){
  if (value == null || value === '') return '';
  
  value = smartFixFloatPrecision(value);
  const str = String(value);
  
  // 如果有小数点，去除末尾的0
  if (str.includes('.')) {
    return str.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  }    
  return str;
}

export function  formatValueRemove2 (value){
  return formatValueRemove0(value[1]);
}

export function  formatValueToDateTime (value){

      const date = new Date(value);
        const year = date.getFullYear();
        const month = (date.getMonth() + 1).toString().padStart(2, '0');
        const day = date.getDate().toString().padStart(2, '0');
        const hours = date.getHours().toString().padStart(2, '0');
        const minutes = date.getMinutes().toString().padStart(2, '0');
        const seconds = date.getSeconds().toString().padStart(2, '0');
        return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;

}


//不用科学记数法，显示完整数据
export function  formatValueNoScientific(value, mult, varDecimal)
{
  const result = (Number(value) || 0) * (Number(mult) || 1);
  
  if (!isFinite(result)) return '0';
  if (result === 0) return '0';
  
  // 确定小数位数
  const decimal = varDecimal !== undefined && varDecimal !== null 
    ? Math.min(Math.max(Number(varDecimal) || 0, 0), 10)
    : 2;
  
  
  let str;
  
  // 正常处理
  const multiplier = Math.pow(10, decimal);
  const rounded = Math.round(result * multiplier) / multiplier;
  str = decimal === 0 ? rounded.toString() : rounded.toFixed(decimal);
  
  // 去除末尾的0
  if (str.includes('.')) {
    str = str.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
  }

  
  return str;
}
//带科学记数法
// 带科学记数法，核心规则：varDecimal指定几则保留几位小数，0也按位数补0（如1→0.0、2→0.00）
export function formatValue(value, mult, varDecimal) {
  
  // 基础计算：空值/非数字转0，避免NaN，完成数值倍率计算
  const result = (Number(value) || 0) * (Number(mult) || 1);
  
  // 非有限数（Infinity/-Infinity）直接返回对应小数位的0（如varDecimal=2则返回0.00）
  if (!isFinite(result)) {
    const decimal = varDecimal !== undefined && varDecimal !== null ? Math.min(Math.max(Number(varDecimal) || 0, 0), 10) : 2;
    return decimal > 0 ? `0.${'0'.repeat(decimal)}` : '0';
  }

  // 确定小数位数：限制0~10（避免位数过大/过小异常），未传默认2，传值则取指定值
  const decimal = varDecimal !== undefined && varDecimal !== null 
    ? Math.min(Math.max(Number(varDecimal) || 0, 0), 10)
    : 2;
  
  // 四舍五入到指定小数位，保证计算精度
  const multiplier = Math.pow(10, decimal);
  const rounded = Math.round(result * multiplier) / multiplier;
  
  // 边界值判断：绝对值小于精度阈值，按decimal补对应位数的0（核心优化：严格匹配位数）
  if (Math.abs(rounded) < Math.pow(10, -decimal) / 2) {
    return decimal > 0 ? `0.${'0'.repeat(decimal)}` : '0';
  }
  
  const absRounded = Math.abs(rounded);
  // 判断是否需要科学记数法（原逻辑保留，兼容超大/超小/原生科学记数法数值）
  const needsScientific = 
    absRounded >= 1e12 ||                    // 数值≥10^12，用科学记数法
    (absRounded < Math.pow(10, -decimal - 1) && absRounded > 0) || // 数值过小，用科学记数法
    rounded.toString().includes('e');        // 原始值已是科学记数法，直接沿用

  if (needsScientific) {
    // 科学记数法：保留decimal位小数，去除末尾无效0（格式更简洁，如1.00e+2→1e+2）
    const sciDecimal = Math.max(decimal, 1);
    let str = rounded.toExponential(sciDecimal);
    str = str.replace(/(\.\d*?)0+e/, '$1e');
    str = str.replace(/\.e/, 'e');
    return str;
  } else {
    // 常规格式化：核心规则→decimal是几就保留几位，直接toFixed(decimal)实现严格补位
    return decimal > 0 ? rounded.toFixed(decimal) : Math.round(rounded).toString();
  }
}

//四舍五入，尾部不保留0，即0.0  返回0
export function formatValueOld(value, mult, varDecimal) {

  const result = (Number(value) || 0) * (Number(mult) || 1);
  
  if (!isFinite(result)) return '0';
  
  // 确定小数位数
  const decimal = varDecimal !== undefined && varDecimal !== null 
    ? Math.min(Math.max(Number(varDecimal) || 0, 0), 10)
    : 2;
  
  // 直接四舍五入到指定小数位
  const multiplier = Math.pow(10, decimal);
  const rounded = Math.round(result * multiplier) / multiplier;
  
  // 检查四舍五入后是否为0
  if (Math.abs(rounded) < Math.pow(10, -decimal) / 2) {
    return '0';
  }
  
  const absRounded = Math.abs(rounded);
  
  // 只有在四舍五入后仍然需要科学计数法时才使用
  const needsScientific = 
    absRounded >= 1e12 ||                    // 太大
    (absRounded < Math.pow(10, -decimal - 1) && absRounded > 0) || // 比精度要求小得多
    rounded.toString().includes('e');        // 本来就是科学计数法
  
  if (needsScientific) {
    // 对于科学计数法，decimal参数控制指数部分的小数位数
    let str = rounded.toExponential(Math.max(decimal, 1));
    str = str.replace(/(\.\d*?)0+e/, '$1e');
    str = str.replace(/\.e/, 'e');
    return str;
    
  } else {
    // 正常格式化
    let str = decimal === 0 
      ? Math.round(rounded).toString() 
      : rounded.toFixed(decimal);
    
    // 去除末尾的0
    if (str.includes('.')) {
      str = str.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '');
    }
    
    return str;
  }
}
 

// 智能的浮点数精度处理
export function smartFixFloatPrecision(num)
 {
  if (num === null || num === undefined || num === '') return num
  
  const number = Number(num)
  if (isNaN(number)) return num
  
  // 如果是整数
  if (number % 1 === 0) return number
  
  // 处理常见的浮点数精度问题
  const strNum = number.toString()
  
  // 检查是否是类似 0.009999999776482582 的情况
  if (strNum.includes('.999999') || strNum.includes('000000')) {
    // 尝试找到最接近的常见小数
    const commonDecimals = [
      0.000001, 0.00001, 0.0001, 0.001, 0.01, 0.1,
      0.2, 0.25, 0.3, 0.333333, 0.4, 0.5, 0.6, 0.666667, 0.7, 0.75, 0.8, 0.9,
      1.5, 2.5, 3.5, 4.5, 5.5
    ]
    
    for (const common of commonDecimals) {
      if (Math.abs(number - common) < 0.000001) {
        return common
      }
    }
  }
  
  // 一般情况：四舍五入到合理的精度
  let precision = 6
  if (Math.abs(number) < 0.0001) precision = 8
  else if (Math.abs(number) < 0.01) precision = 6
  else if (Math.abs(number) < 1) precision = 4
  else if (Math.abs(number) < 100) precision = 2
  else precision = 2
  
  const fixedNum = parseFloat(number.toFixed(precision))
  
  // 去除末尾的0
  const fixedStr = fixedNum.toString()
  if (fixedStr.includes('.')) {
    const trimmed = fixedStr.replace(/(\.\d*?)0+$/, '$1').replace(/\.$/, '')
    return parseFloat(trimmed)
  }
  
  return fixedNum
}